import { createContext, Dispatch, useContext } from 'react'
import { ChannelOnChangeHandler } from '../../../products_v5/components/JoinedForm/ChannelShared/SharedInputs'
import { JoinedFormDepopListing } from '../../../products_v5/components/JoinedForm/types'

interface DepopChannelFormContextValues {
  errors: any
  form: JoinedFormDepopListing
  onListingChange: ChannelOnChangeHandler
  templateForm: any // builder template form for possible autofill attributes
  localErrors: any
  setLocalErrors: Dispatch<any>
  productUnitTracking: boolean // whether the product has unit tracking enabled
}

export const DepopChannelFormContext = createContext<DepopChannelFormContextValues>({
  form: null,
  errors: null,
  onListingChange: (_e, _cb) => {},
  templateForm: null,
  localErrors: {},
  setLocalErrors: () => {},
  productUnitTracking: false
})
export const useDepopChannelFormContext = () => useContext(DepopChannelFormContext)
